module.exports = __webpack_public_path__ + "static/img/icon_receive.a6c46918.svg";